<!-- LayerSvg.vue -->
<template>
  <svg v-if="points" :width="40" :height="40" viewBox="0 0 40 40">
    <polygon v-if="isPolygon" :points="points" fill="#4a90e2" fill-opacity="0.2" stroke="#4a90e2" stroke-width="2" />
    <polyline v-else :points="points" fill="none" stroke="#4a90e2" stroke-width="2" />
  </svg>
</template>

<script>
export default {
  name: "LayerSvg",
  props: {
    layer: {
      type: [Array, String, Object],
      default: () => [],
    },
  },
  computed: {
    // Normalize and scale coordinates to fit SVG
    points() {
      if (!this.layer || !Array.isArray(this.layer) || this.layer.length === 0) return "";
      // Only use the first two elements [lng, lat] for each point, filter out invalid
      const coords = this.layer
        .map((pt) => (Array.isArray(pt) && pt.length >= 2 ? { x: Number(pt[0]), y: Number(pt[1]) } : null))
        .filter((p) => p && !isNaN(p.x) && !isNaN(p.y));

      if (coords.length === 0) return "";
      // Find bounds
      const xs = coords.map((p) => p.x);
      const ys = coords.map((p) => p.y);
      const minX = Math.min(...xs),
        maxX = Math.max(...xs);
      const minY = Math.min(...ys),
        maxY = Math.max(...ys);
      const scale = 36 / Math.max(maxX - minX || 1, maxY - minY || 1);
      // Map to SVG space (with padding), flip Y axis for SVG
      return coords
        .map((p) =>
          [
            ((p.x - minX) * scale + 2).toFixed(1),
            (38 - (p.y - minY) * scale).toFixed(1), // flip Y
          ].join(",")
        )
        .join(" ");
    },
    isPolygon() {
      // If first and last point are the same, treat as polygon
      if (!this.layer || this.layer.length < 3) return false;
      const first = this.layer[0],
        last = this.layer[this.layer.length - 1];
      if (Array.isArray(first) && Array.isArray(last)) {
        return first[0] === last[0] && first[1] === last[1];
      }
      if (first.lng !== undefined && last.lng !== undefined) {
        return first.lng === last.lng && first.lat === last.lat;
      }
      return false;
    },
  },
};
</script>
